import React from 'react';

import {Icon} from '@albert-io/atomic';

interface Props {
  className?: string;
}

/**
 * Per-question lock indicator for student surfaces (admin-locked-assessments, Part 4). A binary
 * full lock in neutral `secondary` (matching the teacher + admin indicators). No tooltip: students
 * are never shown restriction copy or the restricting school (`references/ui-patterns.md`) — the
 * lock is a silent visual cue. Render it only for a restricted question (e.g. gated by
 * `isQuestionRestrictedForStudent`); it carries no decision of its own.
 *
 * A non-interactive, labelled icon so it can sit inside the navigators' `<button>` rows without
 * nesting interactive elements. Clicking the row surfaces the full block-and-message, so
 * keyboard/screen-reader users still reach the explanation via the row.
 */
export function StudentRestrictionIndicator({className}: Props) {
  return (
    <Icon
      icon='lock'
      iconStyle='solid'
      color='secondary'
      aria-label='Restricted question'
      className={className}
    />
  );
}
